import Constants from '../utils/consts';
import Utils from '../utils/utils';

var http = require('follow-redirects').http;
var fs = require('fs');
var qs = require('querystring');


export default async function manageInvestor(uname, token, id, eventId, brokerId, 
                                            name, company, country, phone_number, mobile_number, email_address, 
                                            pdf_profile, second_email_address, more_emails_address, deleteFlag, isAnalyst) {
        
        if (name) name = Utils.escapeString(name);
        if (company) company = Utils.escapeString(company);
        if (country) country = Utils.escapeString(country);
    
        return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': '/apis/manageInvestor.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            console.log(body.toString());
            let asd = body.toString();
            console.log("RES: ", asd);
            resolve(JSON.parse(body.toString()));
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'id' : id,
        'eventId' : eventId,
        'brokerId' : brokerId,
        'name' : name,
        'company' : company,
        'country' : country,
        'phone_number' : phone_number,
        'mobile_number' : mobile_number,
        'email_address' : email_address,
        'pdf_profile' : pdf_profile,
        'second_email_address' : second_email_address,
        'more_emails': more_emails_address || '',
        'deleteFlag' : deleteFlag ? 'true' : 'false',
        'isAnalyst' : isAnalyst,
    });

        req.write(postData);

        req.end();

        
    });
}
